import { AuthzGuard } from "@p0security/frontend-core/react";
import { Outlet, Route } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import { Page } from "../App/Page";
import { CONFIG_ROUTES_ROLES } from "../App/roles";
import { Login } from "../Login";
import { OnboardWorkflows } from "./OnboardWorkflows";
import { WelcomePaths } from "./paths";
import { ChooseProduct } from "./steps/ChooseProduct";
import { ConfigureApprovers } from "./steps/ConfigureApprovers";
import { ResourcePrompt } from "./steps/ResourcePrompt";
import { SetupNotifiers } from "./steps/SetupNotifiers";
import { Success } from "./steps/Success";
import { Welcome } from "./steps/Welcome";

export const WelcomeRoutes = () => (
  <Route
    path={`/o/:orgSlug/${WelcomePaths.Root}`}
    element={
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Page title="Welcome">
          <Login>
            <Outlet />
          </Login>
        </Page>
      </QueryParamProvider>
    }
  >
    <Route index element={<Welcome />} />

    <Route element={<AuthzGuard requirement={CONFIG_ROUTES_ROLES} />}>
      <Route path=":cloudProvider" element={<ChooseProduct />} />

      <Route path={WelcomePaths.Onboarding}>
        <Route path=":cloudProvider">
          <Route
            path={WelcomePaths.InstallResource}
            element={<ResourcePrompt />}
          />

          <Route path={WelcomePaths.Notifiers} element={<SetupNotifiers />} />
          <Route
            path={WelcomePaths.ConfigureApprovers}
            element={<ConfigureApprovers />}
          />

          <Route path={WelcomePaths.Success} element={<Success />} />
          <Route path=":component?/:id?/*" element={<OnboardWorkflows />} />
        </Route>
      </Route>
    </Route>
  </Route>
);
